import SaveButton from "@/components/button/save-button";
import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { SelectablePill } from "@/components/form/selectable-pill";
import { ListRenderer } from "@/components/list/list-renderer";
import { PageTitleComponent } from "@/components/page-title";
import { RecreatePlanAlert } from "@/features/settings/components/recreate-plan-alert";
import { useFavoriteCuisines } from "@/hooks/features/use-favorite-cuisines";
import { useToast } from "@/hooks/ui/use-toast";
import { IonSkeletonText, useIonRouter } from "@ionic/react";
import { useState } from "react";

export default function SettingFoodPreferenceCuisinesPage() {
  const navigation = useIonRouter();
  const [isOpen, setIsOpen] = useState(false);
  const { showSuccess } = useToast();
  const {
    cuisineList,
    selectedCuisines,
    setSelectedCuisines,
    handleSubmit,
    isUpdating,
    isFavoriteCuisinesLoading,
  } = useFavoriteCuisines(() => {
    setIsOpen(true);
  });

  const handleRecreatePlan = () => {
    setIsOpen(false);
    showSuccess("Recreate plan successful");
    navigation.goBack();
  };

  const handleCancel = () => {
    setIsOpen(false);
    navigation.goBack();
  };
  return (
    <ProfilePageContainer className="overflow-y-auto no-scrollbar pb-16">
      <PageTitleComponent
        title="Choose Your Favourite Cuisines"
        description="Pick what you love to eat, and we’ll build your plan around it. "
        className="mt-2 mb-6 w-full"
      />

      <ListRenderer
        items={cuisineList}
        isLoading={isFavoriteCuisinesLoading}
        loadingComponent={
          <div className="w-full grid grid-cols-2 gap-4">
            {Array.from({ length: 10 }).map((_, index) => (
              <IonSkeletonText key={index} className="w-full h-10" animated />
            ))}
          </div>
        }
        emptyComponent={
          <div className="w-full flex flex-col justify-center items-center gap-8 flex-1 text-sm text-gray-500">
            No cuisines found
          </div>
        }
      >
        <div className="w-full grid grid-cols-2 gap-4">
          {cuisineList.map((cuisine) => (
            <SelectablePill
              key={cuisine.value}
              label={cuisine.name}
              selected={selectedCuisines.has(cuisine.value)}
              onClick={() => {
                if (selectedCuisines.has(cuisine.value)) {
                  setSelectedCuisines((prev) => {
                    const next = new Set(prev);
                    next.delete(cuisine.value);
                    return next;
                  });
                } else {
                  setSelectedCuisines((prev) => new Set(prev).add(cuisine.value));
                }
              }}
            />
          ))}
        </div>
      </ListRenderer>

      <SaveButton
        text="Save & Continue"
        onSave={handleSubmit}
        position="fixed"
        disabled={isUpdating}
      />
      <RecreatePlanAlert
        isOpen={isOpen}
        onCancel={handleCancel}
        onConfirm={handleRecreatePlan}
      />
    </ProfilePageContainer>
  );
}
